export default [
  {
    name: 'tripManagement',
    label: 'labels.tripManagement',
    permissionKey: 'trip_management'
    // children: [
    //   {
    //     name: 'trip_add',
    //     label: 'labels.addTrip',
    //     permissionKey: 'trip_add'
    //   },
    //   {
    //     name: 'trip_edit',
    //     label: 'labels.editTrip',
    //     permissionKey: 'trip_edit'
    //   },
    //   {
    //     name: 'trip_delete',
    //     label: 'labels.deleteTrip',
    //     permissionKey: 'trip_delete'
    //   },
    //   {
    //     name: 'trip_archive',
    //     label: 'labels.tripArchive',
    //     permissionKey: 'trip_archive'
    //   }
    // ]
  }
]
